<!-- Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. -->

<ng-content></ng-content>

<i
	(click)="clearInput()"
	aria-hidden="true"
	class="grid-ticket-subcomponent-wrapper__button multi-edit__clear-all material-icons"
	>cancel</i
>
<div
	*ngIf="metadataValue === 'multiple' && !(focus$ | async)"
	class="grid-ticket-subcomponent-wrapper__overlay multiedit-overlay"
>
	{{ multipleValuesLabel }}
</div>
<div
	*ngIf="metadataValue === 'cleared' && !(focus$ | async)"
	class="grid-ticket-subcomponent-wrapper__overlay multiedit-overlay"
>
	All values cleared
</div>
